import { createAction, props } from '@ngrx/store';
import { ILoaderActionPayload } from '../models/loader.model';

export const timelineActions = {
  // load: createAction('load/timeline/load', props<any>()),
  load: createAction('load/timeline/load'),
  done: createAction('load/timeline/done', props<{ state: ILoaderActionPayload; data?: any }>()),
};
